import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { HeroSection } from './components/HeroSection';
import { PainStorySection } from './components/PainStorySection';
import { WhyDietsFailSection } from './components/WhyDietsFailSection';
import { MethodSection } from './components/MethodSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { ForYouSection } from './components/ForYouSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-cream font-sans selection:bg-terracotta/30" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <PainStorySection data-id="element-3" />
        <WhyDietsFailSection data-id="element-4" />
        <MethodSection data-id="element-5" />
        <WhatYouGetSection data-id="element-6" />
        <ForYouSection data-id="element-7" />
        <HowItWorksSection data-id="element-8" />
        <FAQSection data-id="element-9" />
        <FinalCTASection data-id="element-10" />
      </main>

      <Footer data-id="element-11" />
    </div>;
}